/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_No_Events_Clipboard_ErrorInputs */



/**
* | output |
* | --- |
* | "No events found in clipboard" |
*
* @param {Shortcut_Keys_No_Events_Clipboard_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_no_events_clipboard_error = /** @type {((inputs?: Shortcut_Keys_No_Events_Clipboard_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_No_Events_Clipboard_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun evenement trouve dans le presse-papiers")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Ereignisse in der Zwischenablage gefunden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun evento trovato negli appunti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В буфере обмена событий не найдено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron eventos en el portapapeles")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("剪贴板中未找到任何事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クリップボードにイベントが見つかりません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्लिपबोर्ड में कोई इवेंट नहीं मिला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum evento encontrado na área de transferência")
	return /** @type {LocalizedString} */ ("No events found in clipboard")
});